import {
  ChevronDown,
  UserRound,
  Settings,
  LogOut,
} from "lucide-react";
import { useState, useRef, useEffect } from "react";
import PageHelpLink from '../../guide/PageHelpLink';
import PortalPageTitle from '../../components/ui/PortalPageTitle';

export default function VendorTopbar({ collapsed }) {
  const [vendor, setVendor] = useState(null);
  const [showProfile, setShowProfile] = useState(false);

  const profileRef = useRef(null);

  useEffect(() => {
    fetch("/api/vendor/me", {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setVendor(data.vendor);
        } else {
          window.location.href = "/vendorlogin";
        }
      })
      .catch(() => {
        window.location.href = "/vendorlogin";
      });
  }, []);

  useEffect(() => {
    const handleClick = (e) => {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setShowProfile(false);
      }
    };
    const handleKey = event => {
      if (event.key === 'Escape' && showProfile) {
        setShowProfile(false);
        profileRef.current?.querySelector('button')?.focus();
      }
    };
    document.addEventListener("mousedown", handleClick);
    document.addEventListener('keydown', handleKey);
    return () => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener('keydown', handleKey);
    };
  }, [showProfile]);

  return (
    <header
      className={`
        fixed top-0 right-0 z-30 h-20
        ${collapsed ? "left-20" : "left-72"}
        px-10
        flex items-center justify-between
        border-b border-white/10
        bg-gradient-to-b from-black/60 to-black/30
        backdrop-blur-xl
        transition-all duration-300
      `}
    >
      <PortalPageTitle portal="vendor" />

      {/* RIGHT */}
      <div className="flex items-center gap-6">
        <PageHelpLink portal="vendor"/>
        {/* ===== PROFILE ===== */}
        <div className="relative" ref={profileRef}>
          <button type="button" aria-label="Open account menu" aria-expanded={showProfile}
            onClick={() => {
              setShowProfile(!showProfile);
            }}
            className="erp-profile-toggle flex items-center gap-3 px-4 py-2 rounded-xl bg-black/40 border border-white/10 cursor-pointer hover:bg-white/5 transition"
          >
            <UserRound size={18} className="text-amber-400" />
            <div className="text-right leading-tight">
              <p className="text-sm font-medium">{vendor?.name || "..."}</p>
              <p className="text-xs text-gray-400">Vendor</p>
            </div>
            <ChevronDown size={16} />
          </button>

          {showProfile && (
            <div
              className="absolute right-0 mt-3 w-56 rounded-2xl
              bg-[#0b0b0f] border border-white/10 shadow-xl overflow-hidden"
            >
              <div className="px-5 py-4 border-b border-white/10">
                <p className="font-medium">{vendor?.name}</p>
                <p className="text-xs text-gray-400">{vendor?.email}</p>
              </div>

              <a href="/vendordashboard/profile"
                className="w-full flex items-center gap-3 px-5 py-3
                hover:bg-white/5 transition text-sm"
              >
                <Settings size={16} />
                My Profile
              </a>

              <button
                onClick={async () => {
                  try {
                  await fetch("/api/vendor/logout", {
                    method: "POST",
                    credentials: "include",
                  });

                  window.location.href = "/vendorlogin";
                  } catch {window.alert('Unable to log out. Please try again.');}
                }}
                className="w-full flex items-center gap-3 px-5 py-3
                hover:bg-red-500/10 text-red-400 transition text-sm"
              >
                <LogOut size={16} />
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
